import { render, staticRenderFns } from "./Breakdown.vue?vue&type=template&id=1f8702be&scoped=true&"
import script from "./Breakdown.vue?vue&type=script&lang=js&"
export * from "./Breakdown.vue?vue&type=script&lang=js&"
import style0 from "./Breakdown.vue?vue&type=style&index=0&id=1f8702be&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f8702be",
  null
  
)

export default component.exports